var lx = lx || {};
/*
examples:
lx.info.error('Error message!'); // clears previous errors
lx.info.error(['Error message1!','Error message2!']); // list of errors
lx.info.error('Error message!', true); // appends error
lx.info.success('Success message!'); // clears all previous errors and success msgs
lx.info.clear(); // clears all errors and success msgs
lx.info.alert('Alert message!');
lx.info.alert('Alert message!', function () { lx.info.success('Alert closed!'); });
lx.info.confirm('Confirm action', function (okPressed) { if ( okPressed ) lx.info.success('Action confirmed!'); });
*/
lx.info = {
    alert: function (pMsg, pCallback) {
        apex.message.alert(pMsg.replaceAll("<br />", "\n"), pCallback);
    },
    confirm: function (pMsg, pCallback, pLabels){
        let l_original_messages;
        /*if (pLabels) {
            l_original_messages = {"APEX.DIALOG.OK":     lx.tran.get("APEX.DIALOG.OK"),
                                   "APEX.DIALOG.CANCEL": lx.tran.get("APEX.DIALOG.CANCEL")};

            //change the button labels messages
            if (pLabels.ok) apex.lang.addMessages({"APEX.DIALOG.OK":     pLabels.ok});
            if (pLabels.cancel) apex.lang.addMessages({"APEX.DIALOG.CANCEL": pLabels.cancel});

        }
        apex.message.confirm(pMsg, pCallback);

        if (pLabels) {
            //the timeout is required since APEX 19.2 due to a change in the apex.message.confirm
            setTimeout(function () {
                //changes the button labels messages back to their original values
                apex.lang.addMessages({"APEX.DIALOG.OK":     l_original_messages["APEX.DIALOG.OK"]});
                apex.lang.addMessages({"APEX.DIALOG.CANCEL": l_original_messages["APEX.DIALOG.CANCEL"]});
                }, 0);
        }*/
		lx.info.actionConfirm({type:"info",msg:"Are you sure you want to execute this action?", js:pCallback});
    },
    confirmAsync: async (message) => {
        return new Promise((complete, failed)=>{
            let dialog = `<div dialogid="0" class="lxpDialog" id="lxpDialog_CONFIRM">
    <div class="lxpDialog__content" style="max-width:690px">
        <div class="lxpDialog__header">
            <span class="lxpDialog__close" onclick="$('#lxpDialog_CONFIRM').remove();"><i class="far fawe-times" style="position: absolute;top: 16px;right:20px;font-size:1.2rem;"></i></span>
            <h3></h3>
        </div>
        <div class="lxpDialog__body">
            <div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert" style="border: 1px solid #FEF7E0;background-color: #FEF7E0;margin-bottom:0rem;">
                <div class="t-Alert-wrap" style="display: block;text-align: center;">
                    <div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon" style="color: #FFC628;font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div>
                    <div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">`+ message +`</div>
                </div>
            </div>
        </div>
        <div class="footer">
            <nav class="t-Button t-Button--icon t-Button--iconLeft t-Button--primary" onclick="void(0);" type="button" id="confirmYes">
                <span class="t-Icon t-Icon--left far fawe-check"></span>
                <span class="t-Button-label">`+ lx.tran.get("APEX.DIALOG.OK") +`</span>
            </nav>
            <nav class="t-Button t-Button--icon t-Button--iconLeft" id="confirmNo" onclick="void(0);">
                <span class="t-Icon t-Icon--left far fawe-times"></span>
                <span class="t-Button-label">`+ lx.tran.get("APEX.DIALOG.CANCEL") +`</span>
            </nav>
        </div>
    </div>
</div>`;
          $('body').append(dialog);
          $('#confirmYes').off('click');
          $('#confirmNo').off('click');
          
          $('#confirmYes').on('click', ()=> { $('#lxpDialog_CONFIRM').remove(); complete(true); });
          $('#confirmNo').on('click', ()=> { $('#lxpDialog_CONFIRM').remove(); complete(false); });
        });
    },
    clear: function (){
        apex.message.clearErrors();
        apex.message.hidePageSuccess();
    },
    error: function (pErr, pAppend) {
        if (!pAppend) apex.message.clearErrors();
        if (Array.isArray(pErr)) {
            pErr.forEach(msg => {
                apex.message.showErrors({type:"error",location:"page",message: msg});
            });
        } else {
            apex.message.showErrors({type:"error",location:"page",message: pErr});
        }
    },
    success: function (pMsg){
        apex.message.showPageSuccess(pMsg);
    },
    //lx.info.actionConfirm({type:"info",msg:"Are you sure you want to execute this action?", js:"alert('alert');"});
    actionConfirm: function (pOptions) {
        var dialogDiv = lx.dialog.alertMsg({type: $nvl(pOptions.type, "info"), msg: $nvl(pOptions.msg, "Are you sure you want to execute this action?")});
        var lButtons = [];
		
		if (($nvl(pOptions.btn, "ok") == 'ok') || pOptions.btn.includes('ok')) {
          lButtons.push({label: $nvl(pOptions.label, lx.tran.get('APEX.DIALOG.OK')), js: (pOptions.js ? pOptions.js : "") + "$('.lxpDialog').css('display','none');", class: "t-Button--primary", fa:'far fawe-check'});
        }		
		if (($nvl(pOptions.btn, "cancel") == 'cancel') || pOptions.btn.includes('cancel')) {
          lButtons.push({label: lx.tran.get("CANCEL_BTN"), js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});	
		}  

        lx.dialog.open({ id: "actionConfirm", html: dialogDiv, maxWidth: "690px", buttons: lButtons});
    }
}